import React from 'react';

/**
 * Renders either an emoji string or an <img> tag if the value is a URL/path.
 * Use this wherever game settings icons are displayed.
 *
 * @param {string} icon - emoji string or image URL/path
 * @param {string} className - CSS classes for the img tag (default: inline sizing)
 * @param {string} alt - alt text for img
 */
export default function GameIcon({ icon, className = 'inline-block w-5 h-5 object-contain align-middle', alt = '' }) {
  if (!icon) return null;
  if (icon.startsWith('/') || icon.startsWith('http')) {
    return <img src={icon} alt={alt} className={className} />;
  }
  return <>{icon}</>;
}
